export default __webpack_public_path__ + "static/media/216.b73de7fa.png";